export enum DocumentaryProofStatusEnum {
  VALIDATED = 'VALIDATED',
  AWAITING_VALIDATION = 'AWAITING_VALIDATION',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  REFUSED = 'REFUSED'
}
